import React from "react";
import { useScreenTransition } from "../../Hooks/useScreenTransition";
import { useLocation } from "react-router-dom";
import { HashLink } from "react-router-hash-link";

const Footer = ({ windowSize, light = false, menuItems1, menuItems2, menuItems3, defaultPath = "/" }) => {
  const { transitionTo } = useScreenTransition();
  const { pathname } = useLocation();

  const menuItem1 = menuItems1 ? menuItems1: [
    {
      title: "Features",
      path: "/#features",
      hashLink: true,
    },
    {
      title: "Pricing",
      path: "/#pricing",
      hashLink: true,
    },
    {
      title: "Reviews",
      path: "/reviews",
    },
    {
      title: "Order Lookup",
      path: "/order-lookup",
    },
    {
      title: "Doc Verify",
      path: "/verify",
    },
  ];

  const menuItem2 = menuItems2 ? menuItems2: [
    {
      title: "Contact",
      path: "/contact",
    },
    {
      title: "About",
      path: "/about",
    },
    {
      title: "FAQs",
      path: "/faq",
    },
    {
      title: "Use Cases",
      path: "/use-cases",
    },
  ];


  const menuItem3 = menuItems3 ? menuItems3: [
    {
      title: "Privacy Policy",
      path: "/privacy",
    },
    {
      title: "Terms of Service",
      path: "/terms",
    },
    { title: "Refund Policy", path: "/refunds" },
  ];

  const handleMenuClick = (item, e) => {
    if (pathname === defaultPath && item.id) {
      e.preventDefault();
      const element = document.getElementById(item.id);
      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
      }
    } else {
      transitionTo(item.path, e);
    }
  };

  return (
    <div className={`w-full grid gap-8 grid-cols-1 mt-14 ${light ? "lightText" : ""}`}>
      <div className=" container w-full mx-auto grid sm:grid-cols-3 grid-cols-1 gap-8 px-4">
        <img
          src={light ? require("../../assets/eVerbary Logo_Text_Inverted 1.png") : require("../../assets/logo.png")}
          alt="Logo eVerbary"
          className="h-16 w-auto cursor-pointer mb-4 sm:col-span-2"
          onClick={(e) => transitionTo("/?redirect=false", e)}
        />
        <div className="md:flex grid grid-cols-2 justify-between">
          <div className="flex flex-col gap-2">
            {menuItem1.map((item, index) => (
              item.hashLink ? 
              <p
                key={index}
                className="text-tertiary text-base font-medium cursor-pointer"
              >
                <HashLink smooth to={item.path}>{item.title}</HashLink>
              </p>
              :
              <p
                key={index}
                className="text-tertiary text-base font-medium cursor-pointer"
                onClick={(e) => handleMenuClick(item, e)}
              >
                {item.title}
              </p>
            ))}
          </div>
          <div className="flex flex-col gap-2">
            {menuItem2.map((item, index) => (
              item.hashLink ? 
              <p
                key={index}
                className="text-tertiary text-base font-medium cursor-pointer"
              >
                <HashLink smooth to={item.path}>{item.title}</HashLink>
              </p>
              :
              <p
                key={index}
                className="text-tertiary text-base font-medium cursor-pointer"
                onClick={(e) => handleMenuClick(item, e)}
              >
                {item.title}
              </p>
            ))}
          </div>

        </div>
      </div>

      <div className=" container w-full  mx-auto flex  flex-col md:justify-start gap-4 justify-between px-4">
        <p className="text-tertiary text-base font-medium">
          © 2025 eVerbary. All rights reserved.
        </p>
        <div className="sm:flex grid sm:grid-cols-3 grid-cols-2 gap-4 ">
          {menuItem3.map((item, index) => (
            <p
              key={index}
              className="text-primary text-base font-medium cursor-pointer"
              onClick={(e) => transitionTo(item.path, e)}
            >
              {item.title}
            </p>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Footer;
